<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 lg11 pt-6>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card
            class="mx-auto elevation-1 pa-6"
            max-width="1088px"
            align="center"
            outlined
          >
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                sm6
                pb-2
                pb-md-0
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >Sections
              </v-flex>
              <!-- <v-flex
                xs12
                sm3
                md4
                lg4
                pb-2
                pb-md-0
                align-self-center
                class="text-left nsregular"
              >
                <v-text-field
                  v-model="keyword"
                  dense
                  class="rounded-xl"
                  label="Search"
                  outlined
                  hide-details
                  clearable
                ></v-text-field>
              </v-flex> -->
            </v-layout>

            <v-layout wrap justify-space-between py-6>
              <v-flex xs12 align-self-center>
                <v-card flat outlined>
                  <v-layout wrap pa-2>
                    <v-flex xs12 sm6 pa-1 align-self-end text-left>
                      <v-text-field
                        dense
                        outlined
                        label="Section"
                        placeholder="Enter section"
                        hide-details
                        v-model="sectionData.section"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 pa-1 align-self-end text-left>
                      <v-select
                        dense
                        outlined
                        label="Section Type"
                        placeholder="Enter section"
                        hide-details
                        :items="['Pickup','Drop']"
                        v-model="sectionData.type"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm2 align-self-end pa-1>
                      <v-btn
                        width="100px"
                        dark
                        block
                        color="#766BC0"
                        class="rounded-lg"
                        @click="addSection()"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                        <span
                          class="text-left nsregular"
                          style="font-weight: 400; font-size: 12px"
                          >Add Section</span
                        ></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Section</th>
                        <th class="text-left">Type</th>
                        <th class="text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="text-left regular"
                        v-for="(item, i) in sectionList"
                        :key="i"
                      >
                        <td>{{ item.name }}</td>
                        <td>{{ item.type }}</td>
                        <td>
                          <v-layout wrap>
                            <v-flex xs6 align-self-center v-if="item">
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="editCurrent(item)"
                                  >mdi-circle-edit-outline</v-icon
                                ></span
                              >
                            </v-flex>
                            <v-flex xs6 align-self-center>
                              <span
                                ><v-icon
                                  style="cursor: pointer"
                                  @click="(dialoge = true), (curId = item._id)"
                                  >mdi-delete-outline</v-icon
                                ></span
                              >
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
            
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteSection()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="70%" v-model="editdialogue">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Edit Details </v-toolbar-title>
          </v-toolbar>
          <v-layout wrap pa-4>
            <v-flex xs12 align-self-center pa-2>
              <v-text-field
                dense
                hide-details
                outlined
                label="Section"
                v-model="curItem.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-self-center pa-2>
              <v-select
                dense
                hide-details
                outlined
                :items="['Pickup','Drop']"
                label="Section Type"
                v-model="curItem.type"
              ></v-select> </v-flex
            > 
          </v-layout>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="editdialogue = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="editSection()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout wrap>
        <v-flex xs12 pt-4>
          <v-pagination
            small
            color="#766BC0"
            v-model="page"
            :length="Pagelength"
          >
          </v-pagination>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      sectionData: {},
      curItem: {},
      sectionList: null,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      doManual: false,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
    // keyword() {
    //   this.getData();
    // },
  },
  methods: {
    editCurrent(item) {
      this.curItem = item;

      this.editdialogue = true;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/section/get/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          // keyword: this.keyword,
          page: this.page,
          limit: 20,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.sectionList = response.data.data;
            this.Pagelength = Math.ceil(response.data.totalLength / 20);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    //delete button
    deleteSection() {
      axios({
        url: "/bus/admin/delete/sections",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.delete = false;
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            // this.$router.go(-1)
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    //add button
    addSection() {
      if (!this.sectionData.section || !this.sectionData.type) {
        this.msg = "All fields are required*";
        this.showsnackbar = true;
        return;
      } else {
        this.appLoading = true;
        axios({
          url: "/bus/admin/add/sections",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.sectionData,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }

            this.getData();
            this.sectionData = {};
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    //edit button
    editSection() {
      if (!this.curItem.name) {
        this.msg = "Place must be provided.";
        this.showsnackbar = true;
        return;
      } else if (!this.curItem.type) {
        this.msg = "Section type must be provided.";
        this.showsnackbar = true;
        return;
      }   else {
        axios({
          url: "/bus/admin/edit/sections",
          method: "POST",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            id: this.curItem._id,
            section: this.curItem.name,
            type: this.curItem.type, 
          },
        })
          .then((response) => {
            this.editdialogue = false;
            this.appLoading = false;
            if (response.data.status) {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
            this.getData();
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
#map44 {
  height: 100%;
}
</style>
